export default __webpack_public_path__ + "3be6530606817ecc3cb94611a0fc555d.svg";